export default __webpack_public_path__ + "static/selfapp-app-a336926ad2b32efb0935f021fd85e054.jpg";